import React from "react";
import { motion } from "motion/react";

const TeamsTabs = ({ activeTab, setActiveTab }) => {
  return (
    <div className="nav-tabs" style={{ position: "relative" }}>
      <button
        className={`tab-btn press-in-effect ${
          activeTab === "all-users" ? "active" : ""
        }`}
        onClick={() => setActiveTab("all-users")}
      >
        All Users
        {activeTab === "all-users" && (
          <motion.div
            layoutId="active-team-tab-indicator"
            transition={{ type: "spring", bounce: 0.2, duration: 0.6 }}
            style={{
              position: "absolute",
              bottom: "-1px",
              left: "0",
              width: "100%",
              height: "2.5px",
              backgroundColor: "#007bff",
            }}
          />
        )}
      </button>
      <button
        className={`tab-btn press-in-effect ${
          activeTab === "hierarchy" ? "active" : ""
        }`}
        onClick={() => setActiveTab("hierarchy")}
      >
        Hierarchy
        {activeTab === "hierarchy" && (
          <motion.div
            layoutId="active-team-tab-indicator"
            transition={{ type: "spring", bounce: 0.2, duration: 0.6 }}
            style={{
              position: "absolute",
              bottom: "-1px",
              left: "0",
              width: "100%",
              height: "2.5px",
              backgroundColor: "#007bff",
            }}
          />
        )}
      </button>
    </div>
  );
};

export default TeamsTabs;
